import { Component, OnInit } from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder} from '@angular/forms';

import { AuthenicationService } from '../../_services/authenication.service';
import { VentoutwallService } from '../../_services/ventoutwall.service';
import { ToasterService } from '../../_services/toaster.service';

import {environment} from '../../../environments/environment';


declare var $: any;

@Component({
  selector: 'app-get-wall-reply',
  templateUrl: './get-wall-reply.component.html',
  styleUrls: ['./get-wall-reply.component.css']
})
export class GetWallReplyComponent implements OnInit {

  discussionlist: [];
  userdetaild: string;
  returnUrl: string;
  showModalData: {};
  baseUrl: string = environment.baseUrl;
  allowedVentAccessEmails = [];
  id: string = this.route.snapshot.params.id;

  constructor(private formBuilder: FormBuilder, private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private ventoutwallservice: VentoutwallService, private toaster: ToasterService) { }

  ngOnInit() {
    this.allowedVentAccessEmails = ["arushi@mindpeers.co", "sidshuklakhel@gmail.com", "ketakisnatekar@gmail.com", "shreyar@mindpeers.co"]
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  const payload = {
    wall_id: this.id
  };
    this.getWallReply(payload);

  }
  detailsModalPopUp(item:any){
    this.showModalData = item;
  }

  getWallReply(payload) {
    this.ventoutwallservice.getWallReply(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.discussionlist = data.replyList;
            // setTimeout(()=>{
            //   $(function() {
            //     $('#example').DataTable();
            //   });
            // }, 1000);
          } else {
            this.toaster.showError('MindPeers', data.ResponseMessage);
            // setTimeout( () => {
            //   $(function () {
            //     $('#example').DataTable();
            //   });
            // }, 1000);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('MindPeers', error);
          // setTimeout( () => {
          //   $(function () {
          //     $('#example').DataTable();
          //   });
          // }, 1000);
        });
  }

  // deleteWallReply(id){
  //   this.ventoutwallservice.deleteWallReply(id)
  //     .subscribe(
  //       (data: any) => {
  //         if (data && data.ResponseCode === '200') {
  //           //this.toaster.showSuccess('MindPeers', data.ResponseMessage);
  //           const payload = {
  //             wall_id: this.id
  //           };
  //           this.getWallReply(payload);
  //         } else {
  //           this.toaster.showError('MindPeers', data.ResponseMessage);
  //         }
  //         // this.router.navigate([this.returnUrl]);
  //       },
  //       error => {
  //         this.toaster.showError('MindPeers', error);
  //       });
  // }

  updateVent(updateObj){
    this.ventoutwallservice.updateVent(updateObj)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.toaster.showSuccess('Status Changed', data.ResponseMessage);
            // this.reloadComponent();
             //this.toaster.showSuccess('MindPeers', data.ResponseMessage);
             const payload = {
              wall_id: this.id
            };
            this.getWallReply(payload);
          } else {
            this.toaster.showError('MindPeers', data.ResponseMessage);
            const payload = {
              wall_id: this.id
            };
            this.getWallReply(payload);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('MindPeers', error.error.ResponseMessage);
        });
  }

}
